import React, { useEffect, useState, useRef } from "react";
import { getDeductionList, setDeduction } from "@/api/operation";
import {
  Button,
  InputNumber,
  Icon,
  Popconfirm,
  Divider,
  message,
  Table,
  Tooltip,
} from "antd";

const BusinessPage = (props) => {
  const [page, setPage] = useState({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  });

  const [dataSource, setDataSource] = useState([]);

  const [editingIndex, setEditingIndex] = useState(-1);

  const fetchDeductionList = () => {
    getDeductionList().then((res) => {
      if (res.success) {
        setDataSource(
          res.data.map((item, index) => ({
            index: index + 1,
            score: item.score,
            proportion: item.proportion,
          }))
        );
      }
    });
  };

  useEffect(() => {
    fetchDeductionList();
  }, []);

  const handleAdd = () => {
    if (editingIndex !== -1) {
      message.error("请先编辑完整评价扣款规则！");
      return;
    }

    //没有编辑时也触发保存
    setTimeout(()=>{
      document.getElementById('input').focus();
    },100)
    dataSource.push({ index: dataSource.length + 1, score: 2, proportion: 1 });
    setDataSource([...dataSource]);
    setEditingIndex(dataSource.length);
  };

  const footer = () => {
    return (
      <div className="footer">
        <Icon type="plus" />
        <div onClick={handleAdd}>添加扣款规则</div>
      </div>
    );
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setTimeout(()=>{
      document.getElementById('input').focus();
    },100)
  };

  const handleCycleBlur = (index) => {
    const current = dataSource[index - 1];
    if (!current.score || !current.proportion) {
      return;
    }
    setDeduction(
      dataSource.map((item) => ({
        score: item.score,
        proportion: item.proportion,
      }))
    ).then((res) => {
      if (res.success) {
        setEditingIndex(-1);
        fetchDeductionList();
      }
    });
  };

  const handleChange = (value, index, key) => {
    dataSource.splice(index - 1, 1, { ...dataSource[index - 1], [key]: value });
    setDataSource([...dataSource]);
  };

  const handleDelete = (index) => {
    dataSource.splice(index - 1, 1);
    setDataSource([...dataSource]);
    setDeduction(
      dataSource.map((item) => ({
        score: item.score,
        proportion: item.proportion,
      }))
    ).then((res) => {
      if (res.success) {
        setEditingIndex(-1);
        fetchDeductionList();
      }
    });
  };

  return (
    <div className="evaluation position">
      <div className="delivery">
        <div className="title bg-white">评价扣款规则</div>
        <div className="content bg-white">
          <Table
            columns={[
              {
                title: "ID",
                dataIndex: "id",
                render: (text, record) => record.index,
                width: "25%",
              },
              {
                title: () => {
                  return (
                    <div>
                      <span>评价分数</span>
                      <span className="grey">(分数范围2-9)</span>
                    </div>
                  );
                },
                dataIndex: "score",
                render: (text, record) => {
                  return record.index === editingIndex ? (
                    <div>
                      <InputNumber
                        value={text}
                        onBlur={() => handleCycleBlur(record.index)}
                        onChange={(value) =>
                          handleChange(value, record.index, "score")
                        }
                        min={2}
                        max={9}
                        id="input"
                      />
                      <span>分</span>
                    </div>
                  ) : (
                    `${text}`
                  );
                },
                width: "25%",
              },
              {
                title: () => {
                  return (
                    <div>
                      <span>扣款比例</span>
                      <span className="grey">(比例范围1-100)</span>
                      <Tooltip title={"扣除所得分账金额的百分之多少"}>
                        <Icon
                          type="question-circle"
                          theme="filled"
                          style={{ color: "rgba(245, 166, 35, 1)" }}
                        />
                      </Tooltip>
                    </div>
                  );
                },
                dataIndex: "proportion",
                render: (text, record) => {
                  return record.index === editingIndex ? (
                    <div>
                      <InputNumber
                        value={text}
                        onBlur={() => handleCycleBlur(record.index)}
                        onChange={(value) =>
                          handleChange(value, record.index, "proportion")
                        }
                        min={1}
                        max={100}
                      />
                      <span>%</span>
                    </div>
                  ) : (
                    `${text} %`
                  );
                },
                width: "25%",
              },
              {
                title: "操作",
                dataIndex: "",
                render: (text, record) => (
                  <div>
                    <a href="#" onClick={() => handleEdit(record.index)}>
                      编辑
                    </a>
                    <Divider type={"vertical"} />
                    <Popconfirm
                      title="确认删除?"
                      onConfirm={() => handleDelete(record.index)}
                    >
                      <a href="#">删除</a>
                    </Popconfirm>
                  </div>
                ),
              },
            ]}
            dataSource={dataSource}
            footer={footer}
            pagination={false}
          />
        </div>
      </div>
    </div>
  );
};
export default BusinessPage;
